import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";
import { Button } from "@/components/ui/button";
import { SidebarMenuButton } from "@/components/ui/sidebar";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

interface ThemeToggleProps {
  variant?: "button" | "sidebar" | "dropdown";
  size?: "sm" | "default" | "lg";
}

export function ThemeToggle({
  variant = "button",
  size = "default",
}: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  if (variant === "dropdown") {
    return (
      <DropdownMenuItem onClick={toggleTheme}>
        {theme === "light" ? (
          <Moon className="h-4 w-4 mr-2" />
        ) : (
          <Sun className="h-4 w-4 mr-2" />
        )}
        <span>{theme === "light" ? "Dark Mode" : "Light Mode"}</span>
      </DropdownMenuItem>
    );
  }

  if (variant === "sidebar") {
    return (
      <SidebarMenuButton
        onClick={toggleTheme}
        size={size}
        tooltip={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      >
        {theme === "light" ? (
          <Moon className="h-4 w-4" />
        ) : (
          <Sun className="h-4 w-4" />
        )}
        <span>{theme === "light" ? "Dark Mode" : "Light Mode"}</span>
      </SidebarMenuButton>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="h-8 w-8"
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
    >
      {theme === "light" ? (
        <Moon className="h-4 w-4" />
      ) : (
        <Sun className="h-4 w-4" />
      )}
    </Button>
  );
}
